export const isGroupCreative = creative => {
  return (
    [
      'banner',
      'clickout',
      'scroller',
      'slideshow',
      'carousel',
      'hosted-video',
      'instream-video',
    ].indexOf(creative.action) >= 0
  );
};

export const withoutIndex = (arr, indexToRemove) =>
      arr.filter((_item, index) => index !== indexToRemove);
